import React, { FC } from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { Route } from 'react-router-dom';
import ReserveReportList from '../reserve/ReserveReportList';
import { ReserveDetail } from '../reserve/ReserveDetail';
import { PageNotFound } from '../PageNotFound';
import { ReserveCheckout } from '../reserve/ReserveCheckout';
import { ManageSubscriptionsPage } from '../subscriptions/ManageSubscriptionsPage';
import { ManageRenewalsPage } from '../renewals/ManageRenewalsPage';

export const AssistantPage: FC = () => {
    const { path, url } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={`${path}`}>
                <Redirect to={`${url}/reserves`} />
            </Route>
            <Route exact path={`${path}/reserves`}>
                <ReserveReportList />
            </Route>
            <Route exact path={`${path}/reserve/:reserveListId`}>
                <ReserveDetail />
            </Route>
            <Route exact path={`${path}/reserve/:reserveListId/checkout`}>
                <ReserveCheckout />
            </Route>
            <Route exact path={`${path}/subscriptions`}>
                <ManageSubscriptionsPage />
            </Route>
            <Route exact path={`${path}/subscriptions/renewals`}>
                <ManageRenewalsPage />
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};
